import styled from 'react-emotion'

const Tab = styled('div')(({ active, isTabAvailable }) => ({
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    background: active && '#F06F2F',
    transition: 'all 250ms',
    ':hover': {
        cursor: isTabAvailable && 'pointer',
        background: isTabAvailable && !active && '#eee'
    },
    '@media (max-width: 500px)': {
        fontSize: 11
    }
}))

export default Tab


// WEBPACK FOOTER //
// ./src/components/TabComponent.jsx